module.exports = __webpack_public_path__ + "static/media/logo.fcc3e36b.png";